import React,{useEffect} from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  useNavigate,
} from "react-router-dom";

import Home from "../pages/Home";
import About from "../pages/About";
import LinkedInCallback from "../pages/LinkedInCallback";
import JobList from "../pages/JobList";
import JobDetail from "../pages/JobDetail";
import Profil from "../pages/Profil";
import SinavCoz from "../pages/SinavCoz";
import Anket from "../pages/Anket";
import BenimMenu from "../pages/BenimMenu";
import EgitimStep from "../pages/EgitimStep";
import ShiftYonetimi from "../pages/mudur/ShiftYonetimi";

import Navbar from "../components/Navbar";
import PrivateRoute from "../components/PrivateRoute";
import WelcomeVideoPopup from "./WelcomeVideoPopup";

import CareerWizard from "../career/CareerWizard";
import { CareerLanguageProvider } from "../career/CareerLanguage";
import "../styles/App.css";
import {sharedCandidateTarget} from '../career/sharedCandidateLink';

const AppContent = () => {
  const location = useLocation();
  const navigate=useNavigate();
  useEffect(()=>{
    const target=sharedCandidateTarget(location.search);
    if(location.pathname==='/'&&target&&localStorage.getItem('token')&&localStorage.getItem('userRole')==='personel')navigate(target,{replace:true});
  },[location.pathname,location.search,navigate]);

  const tamEkranSayfaMi =
    location.pathname.startsWith("/personel/sinav/") ||
    location.pathname.startsWith("/personel/anket/") ||
    location.pathname.startsWith("/personel/egitim/") ||
    location.pathname.startsWith("/personel/shift-yonetimi");
  return (
    <div className={location.pathname === '/profil' && localStorage.getItem('userRole') === 'personel' ? 'employee-workspace' : undefined}>
      {!tamEkranSayfaMi && <Navbar />}
      {!tamEkranSayfaMi && <WelcomeVideoPopup />}

      <Routes>
        {/* Herkese açık sayfalar */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/joblist" element={<JobList />} />
        <Route path="/ilan/:id" element={<JobDetail />} />
        <Route
          path="/linkedin-callback"
          element={<LinkedInCallback />}
        />

        {/* Giriş gerekli sayfalar */}
        <Route
          path="/profil"
          element={
            <PrivateRoute>
              <Profil />
            </PrivateRoute>
          }
        />

        <Route
          path="/ozgecmisim"
          element={
            <PrivateRoute>
              <CareerWizard />
            </PrivateRoute>
          }
        />

        <Route path="/basvurularim" element={<PrivateRoute><Profil section="applications"/></PrivateRoute>}/>
        <Route path="/evraklarim" element={<PrivateRoute><Profil section="documents"/></PrivateRoute>}/>

        <Route
          path="/personel/egitim/:egitimId"
          element={
            <PrivateRoute>
              <EgitimStep />
            </PrivateRoute>
          }
        />
        {/* Sınav sayfası (Navbar YOK) */}
        <Route
          path="/personel/sinav/:kullaniciSinavId"
          element={
            <PrivateRoute>
              <SinavCoz />
            </PrivateRoute>
          }
        />

        {/* Anket sayfası */}
        <Route
          path="/personel/anket/:modulEgitimAnketId"
          element={
            <PrivateRoute>
              <Anket />
            </PrivateRoute>
          }
        />

        <Route
          path="/benim-menu"
          element={
            <PrivateRoute>
              <BenimMenu />
            </PrivateRoute>
          }
        />

        <Route
          path="/personel/shift-yonetimi"
          element={
            <PrivateRoute>
              <ShiftYonetimi />
            </PrivateRoute>
          }
        />

      </Routes>


    </div>
  );
};

const App = () => {
  return (
    <CareerLanguageProvider>
      <Router>
        <AppContent />
      </Router>
    </CareerLanguageProvider>
  );
};

export default App;
